import { Editor, Element as SlateElement, Transforms } from 'slate'

import { BLOCK_FORMATS, LIST_TYPES } from '../../interface/custom-types'
import { isEmptyBlockHelper } from '../isEmptyBlockHelper'

const typesForUnwrap = [
  ...LIST_TYPES,
  BLOCK_FORMATS.blockQuote,
  BLOCK_FORMATS.code,
  BLOCK_FORMATS.pre,
  BLOCK_FORMATS.listItem,
]

export const unwrapBlocks = (editor: Editor) => {
  const [blockForUnwrap] = Editor.nodes(editor, {
    match: (node) =>
      SlateElement.isElement(node) && typesForUnwrap.includes(node.type as BLOCK_FORMATS),
  })

  if (blockForUnwrap && isEmptyBlockHelper(editor, blockForUnwrap[1])) {
    Transforms.unwrapNodes(editor, {
      match: (n) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        typesForUnwrap.includes(n.type as BLOCK_FORMATS),
      mode: 'all',
    })

    return true
  }

  return false
}
